export default "__VITE_ASSET__BD0CyF3S__"